const LINKS = {};

// 本地开发(npm run serve)走相对路径，由 vue.config.js 的 devServer.proxy 转发；
// 后端指向哪个环境(本地/测试/生产)在 vue.config.js 顶部 API_ENV 处手动切换。
// 生产构建(VUE_APP_URL=production)直连线上域名，不受影响。
switch (process.env.VUE_APP_URL) {
    case 'production':
        LINKS.BASE = 'https://www.jiajiakang.net';
        LINKS.OTHER = '';
        break;
    case 'develop':
        LINKS.BASE = '';
        LINKS.OTHER = '';
        break;
    default:
        LINKS.BASE = '';
        LINKS.OTHER = '';
        break;
}

module.exports = LINKS;
